<!-- =========================================================================================
    File Name: TableSingleSelected.vue
    Description: Add functionality on selecting row
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mt-12 md:mt-0">
      <vx-card title="코스">
        <vs-table v-model="selectedCourse" @selected="handleCourse" :data="courseList" stripe>
          <template slot="thead">
            <vs-th>코스코드</vs-th>
            <vs-th>코스명</vs-th>
            <vs-th>순서</vs-th>
            <vs-th>삭제여부</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].codeKey">
                  {{data[indextr].codeKey}}
              </vs-td>
              <vs-td :data="data[indextr].codeValue">
                  {{data[indextr].codeValue}}
              </vs-td>
              <vs-td :data="data[indextr].codeOrder">
                  {{data[indextr].codeOrder}}
              </vs-td>
              <vs-td :data="data[indextr].deleteYn">
                  {{data[indextr].deleteYn}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card> 
      </div>
    </div>

    <div class="vx-row mt-12">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 md:mt-0">
        <vx-card title="스텝">
          <div class="mb-2">
            <vs-button class="mr-2" size="small" @click="promptNewStep">스텝추가</vs-button>
            <vs-button color="success" size="small" @click="updateStepOrder">업데이트</vs-button>
          </div>
          <vs-table v-model="selectedStep" @selected="handleStep" :data="stepList" stripe>
            <template slot="thead">
                <vs-th>스텝코드</vs-th>
                <vs-th>스텝명</vs-th>
                <vs-th>순서</vs-th>
                <vs-th>삭제여부</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].codeKey">
                      {{data[indextr].codeKey}}
                  </vs-td>
                  <vs-td :data="data[indextr].codeValue">
                      {{data[indextr].codeValue}}
                  </vs-td>
                  <vs-td :data="data[indextr].codeOrder">
                      <vs-input style="width: 80px" type="number" v-model="data[indextr].codeOrder" :value="data[indextr].codeOrder"></vs-input>
                  </vs-td>
                  <vs-td :data="data[indextr].deleteYn">
                      {{data[indextr].deleteYn}}
                  </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card> 
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 md:mt-0">
        <vx-card title="메뉴">
          <div class="mb-2">
            <vs-button class="mr-2" size="small" @click="promptNewMenu">메뉴추가</vs-button>
            <vs-button color="success" size="small" @click="updateMenuOrder">업데이트</vs-button>
          </div>
          <vs-table v-model="selectedMenu" @selected="handleMenu" :data="menuList" stripe>
            <template slot="thead">
                <vs-th>메뉴코드</vs-th>
                <vs-th>메뉴명</vs-th>
                <vs-th>순서</vs-th>
                <vs-th>삭제여부</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].codeKey">
                      {{data[indextr].codeKey}}
                  </vs-td>
                  <vs-td :data="data[indextr].codeValue">
                      {{data[indextr].codeValue}}
                  </vs-td>
                  <vs-td :data="data[indextr].codeOrder">
                      <vs-input style="width: 80px" type="number" v-model="data[indextr].codeOrder" :value="data[indextr].codeOrder"></vs-input>
                  </vs-td>
                  <vs-td :data="data[indextr].deleteYn">
                      <vs-button size="small" color="danger" @click="promptDeleteMenu(data[indextr].codeSeq)">삭제</vs-button>
                      <!-- {{data[indextr].deleteYn}} -->
                  </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card> 
      </div>

    </div>  

    <vs-prompt
      @cancel="clearStepValue"
      @accept="addStep"
      @close="closeStep"
      :is-valid="validStepName"
      title="스텝추가"
      :active.sync="activeNewStepPrompt">
      <div class="con-exemple-prompt">
        <vs-alert color="primary" vs-icon="new_releases">
          {{ this.selectedCourse.codeValue }}({{ this.selectedCourse.codeKey }})에 신규 스텝을 추가합니다.
        </vs-alert>
        <vs-input placeholder="스텝명" v-model="newStepName" class="mt-4 mb-2 w-full" />

        <vs-alert :active="!validStepName" color="danger" vs-icon="new_releases" class="mt-4" >
          스텝명을 입력해 주세요.
        </vs-alert>
      </div>
    </vs-prompt>
      
    <vs-prompt
      @cancel="clearMenuValue"
      @accept="addMenu"
      @close="closeMenu"
      :is-valid="validMenuName"
      title="메뉴추가"
      :active.sync="activeNewMenuPrompt">
      <div class="con-exemple-prompt">
        <vs-alert color="primary" vs-icon="new_releases">
          {{ this.selectedStep.codeValue }}({{ this.selectedStep.codeKey }})에 신규 메뉴를 추가합니다.
        </vs-alert>

        <vs-select class="mt-4 mb-2 w-full" v-model="newMenu">
          <vs-select-item :key="item.value" :value="item" :text="item.label" v-for="item in supportedMenuList" />
        </vs-select>

        <vs-alert :active="!validMenuName" color="danger" vs-icon="new_releases" class="mt-4" >
          추가할 메뉴를 입력해 주세요.
        </vs-alert>
      </div>
    </vs-prompt>

  </div>
</template>

<script>
import { fetchData, putData, postData, deleteData } from '@/api/module'

export default {
  components: {
  },
  watch: {
    
  },
  computed:{
    validStepName () {
      return this.newStepName.length > 0
    },
    validMenuName () {
      return this.newMenu !== null
    }
  },   
  data () {
    return {
      courseList: [],
      stepList: [],
      menuList: [],
      supportedMenuList: [],
      selectedCourse: {},
      selectedStep: {},
      selectedMenu: {},
      activeNewStepPrompt: false,
      activeNewMenuPrompt: false,
      newStepName: '',
      newMenu: null,
      deletedMenu: 0
    }
  },
  methods: {
    promptNewStep () {

      if (this.selectedCourse.codeKey === undefined || this.selectedCourse.codeKey.length === 0) return
      
      this.activeNewStepPrompt = true
    },
    promptNewMenu () {

      if (this.selectedStep.codeKey === undefined || this.selectedStep.codeKey.length === 0) return

      this.activeNewMenuPrompt = true
    },

    promptDeleteMenu (codeSeq) {
      
      this.deletedMenu = codeSeq

      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: '알림',
        text: '삭제 하시겠습니까?',
        accept: this.onMenuDelete,
        acceptText: '삭제'
      })
    },
    onMenuDelete () {
      this.deleteCode(this.deletedMenu)
    },
    async addStep () {
      //alert('아직 지원하지 않습니다.')
      this.$vs.loading()
      try {
        const code = {
          upperCodeSeq: this.selectedCourse.codeSeq,
          codeType: 'STEP',
          //codeKey: this.newMenu.value,
          codeValue: this.newStepName
        }
        await postData('code/step', code)
        
        //this.loadMenu()

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()
    },
    async addMenu () {

      this.$vs.loading()
      try {
        const code = {
          upperCodeSeq: this.selectedStep.codeSeq,
          codeType: 'MENU',
          codeKey: this.newMenu.value,
          codeValue: this.newMenu.label
        }
        await postData('code/step/menu', code)
        
        this.loadMenu()

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()

    },
    closeStep () {
      this.newStepName = ''
    },
    closeMenu () {
      this.newMenu = null
    },
    clearStepValue () {
      this.newStepName = ''
    },
    clearMenuValue () {
      this.newMenu = null
    },
    handleCourse () {

      this.stepList = []
      this.menuList = []
      this.selectedStep = {}
      this.selectedMenu = {}
      this.loadStep()
    },
    handleStep () {
      this.menuList = []
      this.selectedMenu = {}
      this.loadMenu()
    },
    handleMenu () {
      
    },
    updateStepOrder () {
      this.updateCodeOrder(this.stepList)
    },
    updateMenuOrder () {
      this.updateCodeOrder(this.menuList)
    },
    async loadCourse () { 
      try {
        const { data } = await fetchData('code', {codeType: 'COURSE'})
        this.$vs.loading.close()
        this.courseList = data.list 

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    },
    async loadStep () { 
      
      const params = {
        codeType: 'STEP',
        upperCodeSeq: this.selectedCourse.codeSeq
      }

      this.$vs.loading()
      try {
        const { data } = await fetchData('code', params)
        this.stepList = data.list 
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()    
    },
    async loadMenu () { 
      
      const params = {
        codeType: 'MENU',
        upperCodeSeq: this.selectedStep.codeSeq
      }

      this.$vs.loading()
      try {
        const { data } = await fetchData('code', params)
        this.menuList = data.list 
        for (let i = 0; i < this.menuList.length; i++) {
          this.menuList[i].upperCodeKey = this.selectedStep.codeKey
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()    
    },
    async updateCodeOrder (params) {
      
      this.$vs.loading()
      try {
        await putData('code', params)
        
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()
    },
    async deleteCode (codeSeq) {
      this.$vs.loading()
      try {
        await deleteData(`code/step/menu/${codeSeq}`)
        this.loadMenu()
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
      this.$vs.loading.close()
    }
  },
  created () {
    this.supportedMenuList.push()
    this.supportedMenuList.push({label: 'Listening Phonics', value: 'P010'})
    this.supportedMenuList.push({label: 'Speaking Phonics', value: 'P020'})
    this.supportedMenuList.push({label: 'Matching Phonics', value: 'P030'})
    this.supportedMenuList.push({label: 'Writing Phonics', value: 'P040'})
    this.supportedMenuList.push({label: 'Listening Phonics1', value: 'P050'})
    this.supportedMenuList.push({label: 'Listening Phonics2', value: 'P060'})
    this.supportedMenuList.push({label: 'Speaking Phonics1', value: 'P070'})
    this.supportedMenuList.push({label: 'Speaking Phonics2', value: 'P080'})
    this.supportedMenuList.push({label: 'Matching Phonics1', value: 'P090'})
    this.supportedMenuList.push({label: 'Matching Phonics2', value: 'P100'})
    this.supportedMenuList.push({label: 'Writing Phonics1', value: 'P110'})
    this.supportedMenuList.push({label: 'Writing Phonics2', value: 'P120'})

    this.supportedMenuList.push({label: 'Listening Sound', value: 'L010'})
    this.supportedMenuList.push({label: 'Listening with Pictures', value: 'L020'})
    this.supportedMenuList.push({label: 'Listening With Subtitles', value: 'L030'})
    this.supportedMenuList.push({label: 'Listening Korean', value: 'L040'})
    this.supportedMenuList.push({label: 'Listen and Fill In', value: 'L070'})
    this.supportedMenuList.push({label: 'Sentence Dictation Type1', value: 'L080'})
    this.supportedMenuList.push({label: 'Sentence Dictation Type2', value: 'L081'})
 
    this.supportedMenuList.push({label: 'Listening Words', value: 'V010'})
    this.supportedMenuList.push({label: 'Speaking Words', value: 'V020'})
    this.supportedMenuList.push({label: 'Words Dictation 1', value: 'V030'})
    this.supportedMenuList.push({label: 'Words Dictation 2', value: 'V031'})
    this.supportedMenuList.push({label: 'Words Dictation 3', value: 'V032'})
    this.supportedMenuList.push({label: 'Writing Words', value: 'V040'})
    this.supportedMenuList.push({label: 'Checking Words', value: 'V050'})
    this.supportedMenuList.push({label: 'Memorizing Words 1', value: 'V070'})
    this.supportedMenuList.push({label: 'Memorizing Words 2', value: 'V071'})
    //this.menuList.push({label: '(V080) Listening Words(L3~L7)', value: 'V080'})

    this.supportedMenuList.push({label: 'Intonation Reading', value: 'R020'})
    this.supportedMenuList.push({label: 'Speed Reading 1', value: 'R030'})
    this.supportedMenuList.push({label: 'Speed Reading 2', value: 'R031'})
    this.supportedMenuList.push({label: 'Translating', value: 'R040'}) //Reading and Translating
    this.supportedMenuList.push({label: 'Reading and Speaking', value: 'R050'})
    this.supportedMenuList.push({label: 'Shadow Reading', value: 'R060'})

    this.supportedMenuList.push({label: 'Sentence Speaking', value: 'S010'})
    this.supportedMenuList.push({label: 'Role Play', value: 'S020'})
    this.supportedMenuList.push({label: 'Speak Straight 1', value: 'S030'})
    this.supportedMenuList.push({label: 'Speak Straight 2', value: 'S031'})
    this.supportedMenuList.push({label: 'Pattern Practice', value: 'S050'})
    this.supportedMenuList.push({label: 'Pattern Extension 1', value: 'S060'})
    this.supportedMenuList.push({label: 'Pattern Extension 2', value: 'S061'})
    this.supportedMenuList.push({label: 'Pattern Extension 3', value: 'S062'})

    this.supportedMenuList.push({label: 'Matching Sentences', value: 'W010'})
    this.supportedMenuList.push({label: 'Writing Blank Type 1', value: 'W020'})
    this.supportedMenuList.push({label: 'Writing Blank Type 2', value: 'W021'})
    this.supportedMenuList.push({label: 'Writing Blank Type 3', value: 'W022'})
    this.supportedMenuList.push({label: 'Writing Blank Type 4', value: 'W023'})
    //this.menuList.push({label: '(W030) Writing Composition', value: 'W030'})
    
    this.supportedMenuList.push({label: 'Check Up', value: 'C010'})

    this.loadCourse()
  }
}
</script>
